/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each calculator has automated tests that compare its output against reference values before any change goes live.`)
};

const es_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada calculadora tiene pruebas automatizadas que comparan su resultado con valores de referencia antes de que cualquier cambio se publique.`)
};

const de_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Rechner hat automatisierte Tests, die sein Ergebnis vor jeder Veröffentlichung mit Referenzwerten vergleichen.`)
};

const nl_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke rekentool heeft geautomatiseerde tests die de uitkomst vergelijken met referentiewaarden voordat een wijziging live gaat.`)
};

const fr_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque calculatrice dispose de tests automatisés qui comparent son résultat à des valeurs de référence avant la mise en ligne de tout changement.`)
};

const it_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni calcolatrice ha test automatizzati che confrontano il suo risultato con valori di riferimento prima che qualsiasi modifica venga pubblicata.`)
};

const pt_br2_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada calculadora tem testes automatizados que comparam seu resultado com valores de referência antes de qualquer mudança entrar no ar.`)
};

const pt_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada calculadora tem testes automatizados que comparam o seu resultado com valores de referência antes de qualquer alteração entrar em produção.`)
};

const ja_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各計算機には、変更を公開する前に出力を参照値と比較する自動テストがあります。`)
};

const zh_about_verify_li2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每款计算器都有自动化测试，会在任何更改上线前将其输出与参考值进行比对。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_verify_li2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_verify_li2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_verify_li2", locale)
	if (locale === "en") return en_about_verify_li2(inputs)
	if (locale === "es") return es_about_verify_li2(inputs)
	if (locale === "de") return de_about_verify_li2(inputs)
	if (locale === "nl") return nl_about_verify_li2(inputs)
	if (locale === "fr") return fr_about_verify_li2(inputs)
	if (locale === "it") return it_about_verify_li2(inputs)
	if (locale === "pt-BR") return pt_br2_about_verify_li2(inputs)
	if (locale === "pt") return pt_about_verify_li2(inputs)
	if (locale === "ja") return ja_about_verify_li2(inputs)
	return zh_about_verify_li2(inputs)
};